import { render, staticRenderFns } from "./SpecialtyAndTeams.vue?vue&type=template&id=7b897ad2&scoped=true"
import script from "./SpecialtyAndTeams.vue?vue&type=script&lang=js"
export * from "./SpecialtyAndTeams.vue?vue&type=script&lang=js"
import style0 from "./SpecialtyAndTeams.vue?vue&type=style&index=0&id=7b897ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b897ad2",
  null
  
)

export default component.exports